// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"_4Ls9p4--JoinTitleParagraph-module--paragraph"};